import { be } from "../../../../date-fns/locale/be.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    be
  }
};